(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-featured-collection"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const sliderElement = document.querySelector('.nw-feature-collection-slider');
    
    if (sliderElement) {
        const NWfeaturecollectionslider = new Swiper(sliderElement, {
            slidesPerView: 1.5,
            spaceBetween: 16,
            scrollbar: {
                el: '.nw-feature-collection-slider .swiper-scrollbar',
                draggable: true,
            },
            navigation: {
                nextEl: '.nw-feature-collection-slider-container .swiper-button-next1',
                prevEl: '.nw-feature-collection-slider-container .swiper-button-prev1',
            },
            //allowTouchMove: false,
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                    scrollbar: false,
                },
                750: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                    scrollbar: false,
                },
            },
        });
    }
});

    
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-perfect-match"] && !window.DesignMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
    const sliderElement = document.querySelector('.nw-perfect-match-slider');
    
    if (sliderElement) {
        const NWfeaturecollectionslider = new Swiper(sliderElement, {
            slidesPerView: 1.5,
            spaceBetween: 14,
            scrollbar: {
                el: '.nw-feature-collection-slider .swiper-scrollbar',
                draggable: true,
            },
            navigation: {
                nextEl: '.nw-perfect-match-slider-container .swiper-button-next',
                prevEl: '.nw-perfect-match-slider-container .swiper-button-prev',
            },
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                    scrollbar: false,
                },
                750: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                    scrollbar: false,
                },
            },
        });
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-why-love-it"] && !window.DesignMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
    const sliderElement = document.querySelector('.nw-why-love-it-slider');

    if (sliderElement) {
        const NWfeaturecollectionslider = new Swiper(sliderElement, {
            slidesPerView: 1.4,
            speed: 800,
            loop: false,
            spaceBetween: 14,
            navigation: false,
            breakpoints: {
                750: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
            },
        });
    }
});

    
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    function initializeSlider() {
      const sliderElement = document.querySelector('product-recommendations .nw-feature-collection-slider');
      
      if (sliderElement) {
        const NWfeaturecollectionslider = new Swiper(sliderElement, {
          slidesPerView: 1.5,
          spaceBetween: 16,
          scrollbar: {
            el: '.nw-feature-collection-slider .swiper-scrollbar',
            draggable: true,
          },
          navigation: {
            nextEl: 'product-recommendations .nw-feature-collection-slider-container .swiper-button-next1',
            prevEl: 'product-recommendations .nw-feature-collection-slider-container .swiper-button-prev1',
          },
          //allowTouchMove: false,
          breakpoints: {
            1024: {
              slidesPerView: 4,
              spaceBetween: 24,
              scrollbar: false,
            },
            750: {
              slidesPerView: 3,
              spaceBetween: 24,
              scrollbar: false,
            },
          },
        });
      }
    }

    initializeSlider();
    setTimeout(initializeSlider, 2000);
});


  } catch(e) { console.error(e); }
})();
})();
